import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ACTIVITY_FILTER_LIST, ActivityType } from '../filters/activity-filters';
import { SearchQuery } from '../models/search-query.model';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';


@Component({
  selector: 'app-activity-filter-list',
  templateUrl: './activity-filter-list.component.html',
  styleUrls: ['./activity-filter-list.component.scss']
})
export class ActivityFilterListComponent implements OnInit {
  @Input() query: SearchQuery;
  @Input() compact: boolean;
  @Input() selectedActivity: ActivityType;
  @Input() showAttribution = true;
  @Output() selectedActivityChange = new EventEmitter<ActivityType>();

  ACTIVITY_FILTER_LIST = ACTIVITY_FILTER_LIST;

  constructor(private _analyticsService: AnalyticsService) { }

  ngOnInit() {
    this._analyticsService.pageView('airport_landingpage_activities', 'Activities Landing Page filters');
  }

  onClickActivity(type: ActivityType) {
    this.selectedActivity = type;
    this.selectedActivityChange.emit(type);
  }
}
